// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1X5y-","inputWrap":"Table_inputWrap__I3-7w","col":"Table_col__17YPi","bmiTooltip":"Table_bmiTooltip__fK69S"};